// extracted by mini-css-extract-plugin
export default {"overlay":"AuthModal_overlay__kjltQ","modal":"AuthModal_modal__zH3xi","exitModal":"AuthModal_exitModal__LH58t"};